export const marketCloseTime = '16:30';
export const marketEndOfDay = '23:59';
